var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTags(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.8048 7.41102L8.18351 0.789761C7.90606 0.512314 7.52363 0.354843 7.12621 0.354843H1.74972C0.924873 0.354843 0.25 1.02972 0.25 1.85456V7.23105C0.25 7.62848 0.40747 8.01091 0.692417 8.28835L7.31367 14.9096C7.89856 15.4945 8.85089 15.4945 9.43578 14.9096L14.8123 9.53312C15.3972 8.94823 15.3972 8.00341 14.8048 7.41102ZM3.62437 4.854C3.00198 4.854 2.49958 4.35159 2.49958 3.72921C2.49958 3.10683 3.00198 2.60442 3.62437 2.60442C4.24675 2.60442 4.74916 3.10683 4.74916 3.72921C4.74916 4.35159 4.24675 4.854 3.62437 4.854Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/tags.cd674c68eba3123c59dba3aef5c2b977.svg";
export { ForwardRef as ReactComponent };